"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var types_1 = require("./types");
var pool_1 = __importDefault(require("./v0.5/pool"));
var pool_2 = __importDefault(require("./v0.5.1/pool"));
var pool_3 = __importDefault(require("./v0.5.2/pool"));
var pool_4 = __importDefault(require("./v0.6/pool"));
var factory_1 = __importDefault(require("./v0.5/factory"));
var factory_2 = __importDefault(require("./v0.5.1/factory"));
var factory_3 = __importDefault(require("./v0.5.2/factory"));
var factory_4 = __importDefault(require("./v0.6/factory"));
var test_1 = __importDefault(require("./v0.5/test"));
var test_2 = __importDefault(require("./v0.5.1/test"));
var test_3 = __importDefault(require("./v0.5.2/test"));
var test_4 = __importDefault(require("./v0.6/test"));
var dts_1 = __importDefault(require("./dts/dts"));
var ANTE_POOL_CONTRACTS = {
    "default": pool_4.default,
    "v0.5": pool_1.default,
    "v0.5.1": pool_2.default,
    "v0.5.2": pool_3.default,
    "v0.6": pool_4.default,
};
var ANTE_FACTORY_CONTRACTS = {
    "default": factory_4.default,
    "v0.5": factory_1.default,
    "v0.5.1": factory_2.default,
    "v0.5.2": factory_3.default,
    "v0.6": factory_4.default,
};
var ANTE_TEST_CONTRACTS = {
    "default": test_4.default,
    "v0.5": test_1.default,
    "v0.5.1": test_2.default,
    "v0.5.2": test_3.default,
    "v0.6": test_4.default,
};
var DTS_CONTRACTS = {
    "default": dts_1.default,
    "v1": dts_1.default,
};
var Ante = /** @class */ (function () {
    function Ante(network, injectedProvider, defaultProviderKeys) {
        var _this = this;
        this.getProvider = function () {
            return _this.provider;
        };
        this.getPool = function (poolAddress, version) {
            var config = { network: _this.network, provider: _this.provider };
            if (!ANTE_POOL_CONTRACTS[version]) {
                throw new Error('Invalid contract version');
            }
            return new ANTE_POOL_CONTRACTS[version](config, poolAddress);
        };
        this.getTest = function (testAddress, version) {
            var config = { network: _this.network, provider: _this.provider };
            if (!ANTE_TEST_CONTRACTS[version]) {
                throw new Error('Invalid contract version');
            }
            return new ANTE_TEST_CONTRACTS[version](config, testAddress);
        };
        this.getPoolFactory = function (version) {
            var config = { network: _this.network, provider: _this.provider, version: version };
            if (!ANTE_FACTORY_CONTRACTS[version]) {
                throw new Error('Invalid contract version');
            }
            return new ANTE_FACTORY_CONTRACTS[version](config);
        };
        this.getDTS = function (version) {
            if (version === void 0) { version = "v1"; }
            var config = { network: _this.network, provider: _this.provider };
            if (!DTS_CONTRACTS[version]) {
                throw new Error('Invalid contract version');
            }
            return new DTS_CONTRACTS[version](config);
        };
        this.network = network;
        var chainId = types_1.ChainId[network];
        if (!injectedProvider) {
            if (defaultProviderKeys && Object.keys(defaultProviderKeys).length > 0) {
                this.provider = ethers_1.ethers.getDefaultProvider(network, defaultProviderKeys);
            }
            else {
                this.provider = ethers_1.ethers.getDefaultProvider(network);
                console.warn("We recomend using your own API Keys. More details: https://docs.ethers.io/v5/api-keys/");
            }
        }
        else if (typeof injectedProvider === "string") {
            this.provider = new ethers_1.providers.StaticJsonRpcProvider(injectedProvider, chainId);
        }
        else if (injectedProvider instanceof ethers_1.providers.Provider) {
            this.provider = injectedProvider;
        }
        else {
            this.provider = new ethers_1.providers.Web3Provider(injectedProvider, chainId);
        }
    }
    return Ante;
}());
exports.default = Ante;
